export default __webpack_public_path__ + "static/media/charityListing.d66b2e01.png";